import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ReCaptchaService } from 'src/app/services/recaptcha.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    constructor(
        private auth: AuthService,
        private router: Router,
        public loading: LoadingService,
        private title: Title,
        private el: ElementRef,
        private reCaptchaService: ReCaptchaService,
        private toastr: ToastrService
    ) { }
    loginForm = new FormGroup({
        email: new FormControl(null),
        password: new FormControl(null),
    });
    showPassword = false;

    async submitForm(loginForm: any): Promise<void> {
        if (!loginForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();
            return;
        }

        this.loading.start();
        loginForm.disable();

        try {
            const fdata = this.loginForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('login');
            const res: any = await this.auth.login({ email: fdata.email, password: fdata.password, token });

            loginForm.enable();

            if (res.success) {
                this.router.navigate(['/dashboard']);
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    loginForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });
                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });

                return;
            }

            const title = res.response?.message || res.response?.description || 'Oops';
            const desc = res.response?.description || 'Error';
            this.toastr.error(desc, title);

        } catch (error) {
            loginForm.enable();
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');
        } finally {
            this.loading.done();
        }
    }

    ngOnInit(): void {
        this.title.setTitle('Login | MFGM - CMS');
    }

}
